import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Item, ItemColumn, ItemCondition, ItemFormat, ItemOperator } from 'app/models/item.inferface';
import { ColumnsConfigDto, TenantColumnConfigDto } from 'app/models/tenant.model';
import { WorkflowTypeByModuleDto } from 'app/models/workflow/workflow.interface';
import { Observable, of } from 'rxjs';
import { ConfigsLoaderService } from './config-loader.service';
import { map } from 'rxjs/operators';
import { ApplicationItem } from './suggest/application-by-name.suggest.service';

@Injectable({
    providedIn: 'root'
})

export class DataSourceService {

    private readonly useMockData = true;
    private readonly apiEndpoint: string;

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndpoint = this.config.apiUrl;
    }

    getComplaintStatuses(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetComplaintStatus`);
    }

    getComplaintClassifications(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetComplaintClassifications`);
    }

    getFormTypes(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetComplaintTypes`);
    }

    getAlertSources(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetAlertSources`);
    }

    getFormSubTypes(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetFormSubTypes`);
    }

    getAlertStatus(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetAlertStatus`);
    }

    getAlertResolutions(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetAlertResolutions`);
    }

    getCriticality(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetAlertCriticality`);
    }

    getRejectedReasons(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetRejectedReasons`);
    }

    getComplaintClassificationRejectedReasons(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetComplaintClassificationRejectedReasons`);
    }

    getMassiveActions(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetMasiveAlertActions`);
    }

    getCaseTypes(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetCaseTypes`);
    } 

    getCaseStatus(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetCaseStatus`);
    }    

    getCaseTypeAddManual(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Datasource/GetCaseTypesForAddManual`);
    }  
    
    getWorkflowTypes(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetWorkflowTypes`);
    } 

    getReportSettings(reportTypeId: number){
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetReportSettings?reportTypeId=${reportTypeId}`);
    }

    getWorkflowTypeByModule(){
        return this.httpClient.get<WorkflowTypeByModuleDto[]>(`${this.apiEndpoint}/DataSource/WorkflowTypeByModule`);
    }

    getWorkflowTypeByModuleId(moduleId: number){
        return this.httpClient.get<WorkflowTypeByModuleDto[]>(`${this.apiEndpoint}/DataSource/GetWorkflowTypeByModuleId/${moduleId}`);
    } 

    getTenantApplicationGroup(): Observable<Item[]>{
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/TenantApplicationGroup`);
    }

    getApplicationGroup(): Observable<Item[]>{
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/ApplicationGroup`);
    }

    getApplications(): Observable<ApplicationItem[]>{
        return this.httpClient.get<ApplicationItem[]>(`${this.apiEndpoint}/DataSource/Applications`);
    }

    getDynamicFilterByAplicationGroup(moduleId: number): Observable<Item[]>{
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Datasource/DynamicFilterByAplicationGroup?moduleId=${moduleId}`);
    }

    getTenantColumnsConfigByModule(moduleId){//
        return this.httpClient.get<ColumnsConfigDto[]>(`${this.apiEndpoint}/DataSource/TenantColumnsSettingByModule?moduleId=${moduleId}`);
    }

    saveTenantColumnConfiguration(columnsConfig: ColumnsConfigDto[]){
        return this.httpClient.post(`${this.apiEndpoint}/DataSource/TenantColumnSetting`, columnsConfig);
    }

   
    getContentTypes(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetContentTypes/`)
          .pipe(
            map(response => {
              return response;
            }),
          );
    }

      getQuestionTypes(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetQuestionTypes/`)
          .pipe(
            map(response => {
              return response;
            }),
          );
      }

      getWorkflowActions(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetWorkflowActions/`)
          .pipe(
            map(response => {
              return response;
            }),
          );
      }

      getControlResolutions(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/DataSource/GetAlertResolutions`);
    }

    getControlStatus(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllStatus`);
    }

    getControlRisk(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllRisk`);
    }

    getControlProcess(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllProccess`);
    }

    getControlTypes(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllTypes`);
    }

    getControlResponsible(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllResponsible`);
    }

    getControlPeriodicity(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllPeriodicity`);
    }

    getControlFunction(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllFunction`);
    }

    getControlFormat(): Observable<ItemFormat[]> {
        return this.httpClient.get<ItemFormat[]>(`${this.apiEndpoint}/Catalog/GetFormat`);
    }

    getControlPhraseControlMode(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllPhraseControlMode`);
    }

    getControlPhraseConnector(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllSearchConector`);
    }

    getControlColumn(): Observable<ItemColumn[]> {
        return this.httpClient.get<ItemColumn[]>(`${this.apiEndpoint}/Catalog/GetControlColumnType`);
    }

    getControlOperatorControl(): Observable<ItemOperator[]> {
        return this.httpClient.get<ItemOperator[]>(`${this.apiEndpoint}/Catalog/GetOperator`);
    }

    getControlTrigger(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllStatus`);
    }

    getControlAmountCondition(): Observable<ItemCondition[]> {
        return this.httpClient.get<ItemCondition[]>(`${this.apiEndpoint}/Catalog/GetConditionAmount`);
    }

    getControlDateCondition(): Observable<ItemCondition[]> {
        return this.httpClient.get<ItemCondition[]>(`${this.apiEndpoint}/Catalog/GetConditionDate`);
    }

    getParameterizationStatus(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/ControlParameterization/GetAllStatus`);
    }

    getParameterizationRulesStatus(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllStatus`);
    }

    getExecutionStatus(): Observable<Item[]> {
        return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Control/GetAllStatus`);
    }
}
